import React from "react";
import NoTableData_Jupiter from "./NoTableData_Jupiter";

function Table_Jupiter(props) {
  let { data, post_fix } = props;

  return (
    <>
      <table className="table table-striped">
        <thead style={{ backgroundColor: "#32879c", color: "#fff" }}>
          <tr>
            <th scope="col" className="cols">
              Vin
            </th>
            <th scope="col">value</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <NoTableData_Jupiter />
          ) : (
            data.map((x) => {
              return (
                <tr key={x.key}>
                  <td
                    scope="row "
                    className="hand_geture"
                    onClick={() => props.singleVinSelected(x.key)}
                  >
                    {x.key}
                  </td>
                  <td>{x.value !== null ? x.value.toFixed(2) : 0}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </>
  );
}

export default Table_Jupiter;
